export type ClientCache<T> = {
  clear: () => void;
  get: (key: string, factory: () => T) => T;
};

export function createClientCache<T>(): ClientCache<T> {
  let currentClient: T | null = null;
  let currentKey: string | null = null;

  return {
    clear() {
      currentClient = null;
      currentKey = null;
    },
    get(key, factory) {
      if (currentClient && currentKey === key) {
        return currentClient;
      }

      currentKey = key;
      currentClient = factory();
      return currentClient;
    },
  };
}
